<div class="card">
    <div class="font-semibold text-xl mb-4 flex items-center gap-2">
        Ordenes Emitidas HOY - Tomografías
        <p-tag [value]="orders.length.toString()" severity="info"></p-tag>
    </div>
    <p-table [value]="orders" [loading]="loading" [paginator]="true" dataKey="idOrder" [rows]="10" [rowHover]="true">
        <ng-template #header>
            <tr>
                <th pSortableColumn="patientCi">Cédula <p-sortIcon field="patientCi"></p-sortIcon></th>
                <th pSortableColumn="patientName">Nombre <p-sortIcon field="patientName"></p-sortIcon></th>
                <th pSortableColumn="branchName">Sucursal <p-sortIcon field="branchName"></p-sortIcon></th>
                <th>Estado</th>
                <th>Acciones</th>
            </tr>
        </ng-template>
        <ng-template #body let-order>
            <tr>
                <td>{{ order.patientCi }}</td>
                <td>{{ order.patientName }}</td>
                <td>{{ order.branchName }}</td>
                <td><p-tag [value]="statusLabel(order.statusCode)" [severity]="statusSeverity(order.statusCode)"></p-tag></td>
                <td>
                    <button pButton icon="pi pi-eye" text rounded severity="info" pTooltip="Ver detalle de la orden" (click)="openOrderDetail(order)"></button>
                </td>
            </tr>
        </ng-template>
        <ng-template #emptymessage>
            <tr>
                <td colspan="5" class="text-center">Hoy no hay órdenes con estudios TOMO.</td>
            </tr>
        </ng-template>
    </p-table>
</div>
